import * as ShedsAPI from '../common/helpers/ShedsAPI';
import { AdRequestForm } from '../pages/display-ads/AdRequest';

export const getAdRequests = async (params: {
	skip: number;
	limit: number;
	accountId?: number;
}) => {
	return ShedsAPI.get('api', '/getAdRequests', {
		queryStringParameters: params,
	});
};

export const updateAdRequests = async (
	updatedFields: Partial<AdRequestForm>,
	adRequestId?: number,
	accountId?: number
) => {
	return ShedsAPI.put('api', `/${accountId}/updateAdRequests/${adRequestId}`, {
		body: updatedFields,
	});
};

export const requestAd = async (val: Partial<AdRequestForm>) => {
	return ShedsAPI.post('api', `/adRequest`, {
		body: val,
	});
};

export const invoiceRequestedAd = async (requestId: number) => {
	return ShedsAPI.post('api', `/invoiceRequestedAd/${requestId}`, {});
};

export const getRequestedAds = async (loc: string, accountId?: number) => {
	return ShedsAPI.get('api', `/${accountId}/getRequestedAds`, {
		queryStringParameters: { location: loc },
	});
};


export const trackClick = async (id: number) => {
	return ShedsAPI.post('api', `/trackAdClicks/${id}`, {});
};

export const cancelAdRequest = async (requestId: number) => {
	return ShedsAPI.post('api', `/cancelAdRequest/${requestId}`, {});
};

export const getDisplayAdRequests = async (params: {
	skip: number;
	limit: number;
}) => {
	return ShedsAPI.get('api', '/getDisplayAdRequests', {
		queryStringParameters: params,
	});
};

export const invoiceDisplayAd = async (id: number) => {
	return ShedsAPI.post('api', `/invoiceDisplayAd/${id}`, {});
};

export const cancelDisplayAd = async (id: number) => {
	return ShedsAPI.post('api', `/cancelDisplayAd/${id}`, {});
};

export const updateDisplayAd = async (id: number, updatedFields: any) => {
	return ShedsAPI.put('api', `/updateDisplayAd/${id}`, { body: updatedFields });
};
